<template>
  <v-container class="pagelogin">
  <div style="height: 18vh;"></div>
  <div class="loginForm">

    <v-card
    class="mx-auto pa-12 pb-8 login-card"
      elevation="8"
      max-height="615px"
      rounded="lg"
      width="400px"
    >
      <div class="text-subtitle-1 text-medium-emphasis">Email</div>

      <v-text-field
        density="compact"
        placeholder="Email address"
        prepend-inner-icon="mdi-email-outline"
        variant="outlined"
        v-model="email"
      ></v-text-field>

      <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
        Password
      </div>

      <v-text-field
        :append-inner-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
        :type="passwordVisible ? 'text' : 'password'"
        density="compact"
        placeholder="Enter your password"
        prepend-inner-icon="mdi-lock-outline"
        variant="outlined"
        @click:append-inner="passwordVisible = !passwordVisible"
        v-model="password"
      ></v-text-field>

      <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
        Captcha
      </div>
      <CaptchaWidget ref="altchaWidget" @captcha-verified="handleCaptchaVerified"></CaptchaWidget>
      <br>


      <v-btn
        block
        class="mb-8"
        color="blue"
        size="large"
        variant="tonal"
        @click="login"
      >
      Login
      </v-btn>


      <v-card-text class="text-center">
        <router-link class="text-decoration-none"  style="color:grey" to="/forgot-password">I forgot my password <v-icon icon="mdi-chevron-right"></v-icon></router-link>
        <br><br>
        Don’t have an account?
        <br>
        <router-link class="text-decoration-none"  style="color:grey" to="/register">Sign up now <v-icon icon="mdi-chevron-right"></v-icon>
        </router-link>

      </v-card-text>
    </v-card>
  </div>
</v-container>
</template>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Login | XSINT Intelligence',
  meta: [  
    { name: 'keywords', content: 'login, sign in, account connexion, XSINT, XSINT Intelligence, xsint' },
    
    { property: 'og:title', content: 'Login | XSINT Intelligence' },
    { name: 'twitter:title', content: 'Login | XSINT Intelligence' },

    { name: 'description', content: 'Login to your XSINT account to search for email addresses, phone numbers, IP addresses' },
    { property: 'og:description', content: 'Login to your XSINT account to search for email addresses, phone numbers, IP addresses' },
    { name: 'twitter:description', content: 'Login to your XSINT account to search for email addresses, phone numbers, IP addresses' },

    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/login' },
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'XSINT Intelligence' }
  ]
});
</script>

<script>
import CaptchaWidget from '@/components/CaptchaWidget.vue';
import { useToast } from "vue-toastification";
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    email: '',
    password: '',
    passwordVisible: false,
    captcha_payload: null
  }),
  created(){
    /* eslint-disable */
    const _0x2ab8f4 = _0x4126;
    (function (_0x59c7de, _0x4cd65b) {
      const _0x389702 = _0x4126, _0x22ef3f = _0x59c7de();
      while (true) {
        try {
          const _0x2f9559 = parseInt(_0x389702(506)) / 1 * (-parseInt(_0x389702(490)) / 2) + parseInt(_0x389702(495)) / 3 * (-parseInt(_0x389702(503)) / 4) + parseInt(_0x389702(517)) / 5 * (parseInt(_0x389702(505)) / 6) + -parseInt(_0x389702(518)) / 7 + parseInt(_0x389702(492)) / 8 + -parseInt(_0x389702(500)) / 9 + parseInt(_0x389702(507)) / 10 * (parseInt(_0x389702(484)) / 11);
          if (_0x2f9559 === _0x4cd65b) break; else _0x22ef3f.push(_0x22ef3f.shift());
        } catch (_0x14687b) {
          _0x22ef3f.push(_0x22ef3f.shift());
        }
      }
    }(_0x5d8a, 566727), function (_0x2e9835, _0x4c2f0b) {
      const _0x42689b = _0x4126, _0x3de402 = _0x50c7, _0x2be7a4 = _0x2e9835();
      while (true) {
        try {
          const _0x5b49c9 = parseInt(_0x3de402(476)) / 1 * (-parseInt(_0x3de402(480)) / 2) + -parseInt(_0x3de402(479)) / 3 + -parseInt(_0x3de402(490)) / 4 + parseInt(_0x3de402(471)) / 5 * (parseInt(_0x3de402(482)) / 6) + parseInt(_0x3de402(501)) / 7 * (-parseInt(_0x3de402(483)) / 8) + -parseInt(_0x3de402(491)) / 9 * (-parseInt(_0x3de402(494)) / 10) + parseInt(_0x3de402(486)) / 11;
          if (_0x5b49c9 === _0x4c2f0b) break; else _0x2be7a4[_0x42689b(493)](_0x2be7a4[_0x42689b(516)]());
        } catch (_0x3b7a9b) {
          _0x2be7a4[_0x42689b(493)](_0x2be7a4[_0x42689b(516)]());
        }
      }
    }(_0xaf17, 692119));
    function _0xaf17() {
      const _0x4d375d = _0x4126, _0x4ba641 = ["The site protection has detected suspicious activity.\nWe remind you that using a webdriver is prohibited!", _0x4d375d(487), "4845492ONzQRn", _0x4d375d(509), "28WXprgA", "10SPWRQj", "length", _0x4d375d(493), "8880276FmVhzN", _0x4d375d(501), _0x4d375d(504), "clientX", _0x4d375d(499), "3717411VxwLIN", _0x4d375d(498), _0x4d375d(488), _0x4d375d(496), _0x4d375d(513), _0x4d375d(514), _0x4d375d(489), "24051247szsGWX", _0x4d375d(486), "reload", _0x4d375d(515), _0x4d375d(519), "909IUHsUq", _0x4d375d(494), _0x4d375d(491), _0x4d375d(512), _0x4d375d(485), _0x4d375d(516)];
      return _0xaf17 = function () {
        return _0x4ba641;
      }, _0xaf17();
    }
    const _0x62b534 = _0x3f55;
    (function (_0x277d13, _0x403e00) {
      const _0x491c21 = _0x50c7, _0x29dded = _0x3f55, _0xc0c71e = _0x277d13();
      while (true) {
        try {
          const _0x237293 = parseInt(_0x29dded(338)) / 1 + parseInt(_0x29dded(331)) / 2 * (-parseInt(_0x29dded(340)) / 3) + -parseInt(_0x29dded(330)) / 4 * (parseInt(_0x29dded(336)) / 5) + parseInt(_0x29dded(337)) / 6 + -parseInt(_0x29dded(334)) / 7 * (parseInt(_0x29dded(327)) / 8) + parseInt(_0x29dded(343)) / 9 + parseInt(_0x29dded(328)) / 10;
          if (_0x237293 === _0x403e00) break; else _0xc0c71e[_0x491c21(473)](_0xc0c71e.shift());
        } catch (_0x2a8c0e) {
          _0xc0c71e[_0x491c21(473)](_0xc0c71e[_0x491c21(496)]());
        }
      }
    }(_0x530a, 796780));
    function _0x4126(_0x1b75cf, _0xabf620) {
      const _0x5d8a34 = _0x5d8a();
      return _0x4126 = function (_0x412611, _0x1bc65f) {
        _0x412611 = _0x412611 - 484;
        let _0x25e031 = _0x5d8a34[_0x412611];
        return _0x25e031;
      }, _0x4126(_0x1b75cf, _0xabf620);
    }
    function _0x3f55(_0x50abc8, _0x45a04a) {
      const _0x556b9c = _0x530a();
      return _0x3f55 = function (_0x332e25, _0x537ad8) {
        _0x332e25 = _0x332e25 - 326;
        let _0xf16f22 = _0x556b9c[_0x332e25];
        return _0xf16f22;
      }, _0x3f55(_0x50abc8, _0x45a04a);
    }
    function _0x50c7(_0x612f0c, _0x30c435) {
      const _0x288525 = _0xaf17();
      return _0x50c7 = function (_0x3acb6e, _0x1d4df8) {
        _0x3acb6e = _0x3acb6e - 471;
        let _0x577504 = _0x288525[_0x3acb6e];
        return _0x577504;
      }, _0x50c7(_0x612f0c, _0x30c435);
    }
    const CAP51456 = {CAP5842: [], CAP6485: []};
    function _0x530a() {
      const _0x127407 = _0x4126, _0x5d0450 = _0x50c7, _0x48dd2e = [_0x5d0450(499), _0x5d0450(475), _0x5d0450(489), _0x5d0450(488), _0x5d0450(500), _0x5d0450(484), _0x127407(502), _0x5d0450(497), _0x127407(510), _0x5d0450(492), _0x127407(508), _0x5d0450(473), _0x5d0450(493), _0x127407(511), _0x5d0450(481), _0x5d0450(474), _0x5d0450(495), _0x5d0450(498), _0x5d0450(485), _0x5d0450(472), _0x5d0450(487)];
      return _0x530a = function () {
        return _0x48dd2e;
      }, _0x530a();
    }
    function _0x5d8a() {
      const _0x550c61 = ["4049530EdHnAR", "3077264ROOBDo", "15425XbcEbo", "12270yXxLbs", "5371KirEXM", "19494610DuTFEt", "clientY", "addEventListener", "59932WuaYGy", "keydown", "62710MRkgMb", "2716192hYhqfj", "176GNccEK", "mousemove", "shift", "1685KgJEMm", "2682596CgLUax", "1911200BJLQna", "11EUupzC", "1075639lmyYdB", "location", "CAP5842", "440GJFzIT", "3460668LbkrGW", "418ysYROD", "73241NpozAj", "7845184ofgpHs", "push", "2bSsYOl", "3wYQpqv", "4137612gKTBip", "innerWidth", "56uNUcrQ", "CAP6485", "6997176nehtdX", "key"];
      _0x5d8a = function () {
        return _0x550c61;
      };
      return _0x5d8a();
    }
    document[_0x2ab8f4(509)](_0x62b534(345), function (_0x414342) {
      const _0x2e6aa7 = _0x50c7, _0x5bbfd8 = _0x62b534;
      let _0x24cdf3 = _0x414342[_0x2e6aa7(477)], _0xc2bd7d = _0x414342[_0x5bbfd8(332)];
      CAP51456[_0x5bbfd8(339)][_0x5bbfd8(333)]([_0x24cdf3, _0xc2bd7d]);
    }), document[_0x62b534(326)](_0x62b534(335), function (_0x1e59b6) {
      const _0x50dccd = _0x2ab8f4, _0xf294e2 = _0x50c7, _0x3ae006 = _0x62b534;
      let _0x1159c1 = _0x1e59b6[_0x3ae006(344)];
      CAP51456[_0xf294e2(478)][_0x3ae006(333)](_0x1159c1), CAP51456[_0x3ae006(339)].length < 7 && CAP51456[_0xf294e2(478)][_0x3ae006(341)] >= 10 && window[_0x50dccd(497)] >= 768 && (alert(_0x3ae006(329)), this[_0x3ae006(342)][_0x3ae006(346)]());
    });
  },
  
  computed: {
    ...mapGetters(['backend']),
  },

  components: {
    CaptchaWidget
  },

  methods: {
    handleCaptchaVerified(payload) { this.captcha_payload = payload },
    async login(){
      const toast = useToast();
      try{
        const response = await this.$axios.post(`${this.backend}/api/user/login`, {
          email: this.email,
          password: this.password,
          captcha_payload: this.captcha_payload
        });
        const authToken = response.data.authToken
        const userdata = response.data.userdata
        localStorage.setItem('Authorization', "Bearer "+authToken);
        document.cookie = `Authorization=${authToken}; path=/; domain=.xsint-intelligence.com; secure; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
        localStorage.setItem('userdata', JSON.stringify(userdata));
        window.location.href = '/';
      }catch(err){
        toast.error((err.response.data.error).toString())
      }
      this.$refs.altchaWidget.resetCaptcha();
      this.captcha_payload = null
    }
  }
}
</script>

<style scoped>

.pagelogin{
  display: flex;
    align-items: center; 
    justify-content: center;
    height: 100vh;  
}

  .loginForm {
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: flex-start; 
    position: relative;
  }

  .login-card{
    background-color: rgba(34, 34, 34, 0.459);
  }

  

</style>
